import { useTranslation } from 'react-i18next';

import Button from 'components/library/Button/Button';
import styles from './Modal.module.css';
import { domains } from 'global';

export default function LoginModal() {
  const { t } = useTranslation();

  return (
    <div className={styles.bodyModal}>
      <h3 className={styles.colorText}>{t('modal.loginTitle')}</h3>
      <p className={`${styles.text} ${styles.font30}`}>{t('modal.loginDescription')}</p>
      <Button
        className={styles.button}
        variant="fill"
        type="secondary"
        label={t('modal.createAccount')}
        onButtonClick={() => document.location.assign(`${domains.auth}/create-account?auto_login=2&redirect=${window.location.origin}%3Fmodal=2`)}
      />
      <p className={`${styles.text} ${styles.font14}`}>
        {t('modal.connect')}
        &nbsp;
        <Button
          className={styles.ghostButton}
          variant="ghost"
          type="secondary"
          label={t('navigation.login')}
          onButtonClick={() => document.location.assign(`${domains.auth}?auto_login=2&redirect=${window.location.origin}%3Fmodal=2`)}
        />
      </p>
    </div>
  );
}
